import { type FormEvent, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShiftAuth } from '../../contexts/ShiftAuthProvider';
import { shiftAuthService } from '../../services/auth/shift-auth.service';
import { resolveLoginErrorMessage } from '../../utils/request-errors.utils';

export function useLoginPageController() {
  const navigate = useNavigate();

  const { isAuthenticated, login } = useShiftAuth();

  const [tenantId, setTenantId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const submitLock = useRef(false);

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (submitLock.current) return;
    const normalizedTenantId = tenantId.trim();
    const normalizedUsername = username.replace(/\s+/g, '').toLowerCase();
    const passwordAsEntered = password;
    if (!normalizedTenantId || !normalizedUsername || !passwordAsEntered) {
      setError('יש להזין שם עסק, שם משתמש וסיסמה.');
      return;
    }
    submitLock.current = true;
    setError(null);
    setIsLoading(true);

    try {
      const payload = await shiftAuthService.login(normalizedTenantId, normalizedUsername, passwordAsEntered);
      login(payload);
      navigate('/', { replace: true });
    } catch (requestError: unknown) {
      setError(resolveLoginErrorMessage(requestError));
    } finally {
      submitLock.current = false;
      setIsLoading(false);
    }
  };

  return { isAuthenticated, tenantId, setTenantId, username, setUsername, password, setPassword, error, isLoading, onSubmit };
}
